import { cn } from '@/lib/utils'
import Image from 'next/image'
import { HtmlHTMLAttributes } from 'react'
import { data } from './search-bar'

const Input = ({
  className,
  placeholder,
  extra,
  icon,
  label,
  ...props
}: HtmlHTMLAttributes<HTMLDivElement> & any) => {

  return (
    <div
      className={cn(
        'relative flex grow flex-col border-l border-l-gray bg-white',
        className
      )}
    >
      <label className="absolute -top-5 whitespace-nowrap text-[14px] text-grayText">
        {label}
      </label>
      <div className="my-auto flex w-full items-center pl-3 ">
        {icon && (
          <Image
            src={icon}
            alt="icon"
            width={30}
            height={30}
            className="aspect-square w-6"
          />
        )}
        <input
          placeholder={placeholder}
          className="my-auto w-full pl-3 text-[14px] caret-gray outline-none placeholder:text-blue-gray-200"
          {...props}
        />
        <span className="mr-6 whitespace-nowrap text-xs">{extra}</span>
      </div>
    </div>
  )
}

export default Input
